import React from 'react';
import styles from './SponsoredProductsDescription.module.scss';

const SponsoredProductsDescription = () => (
  <div className={styles.sponsoredDescriptionLayout}>
    <div className={styles.sponsoredDescriptionWrapper}>
      <h2 className={styles.sponsoredDescriptionWrapperTitle}>
        Get a FREE GIFT
      </h2>
      <p className={styles.sponsoredDescriptionText}>
        Spend $15 and you can unlock the free gift below! Hurry, it&apos;s only
        supplies last and your cart total must be $15 or more at the close of
        sale.
      </p>
    </div>
  </div>
);

export default SponsoredProductsDescription;
